import { createBlueprint as p } from "@made-people/blueprint";
const r = p({
  slots: {
    wrapper: ""
  },
  variants: {
    y: {
      none: { wrapper: "" },
      "5xs": { wrapper: "" },
      "4xs": { wrapper: "" },
      "3xs": { wrapper: "" },
      "2xs": { wrapper: "" },
      xs: { wrapper: "" },
      sm: { wrapper: "" },
      md: { wrapper: "" },
      lg: { wrapper: "" },
      xl: { wrapper: "" },
      "2xl": { wrapper: "" },
      "3xl": { wrapper: "" },
      "4xl": { wrapper: "" },
      "5xl": { wrapper: "" },
      "6xl": { wrapper: "" },
      "7xl": { wrapper: "" }
    },
    x: {
      none: { wrapper: "" },
      "5xs": { wrapper: "" },
      "4xs": { wrapper: "" },
      "3xs": { wrapper: "" },
      "2xs": { wrapper: "" },
      xs: { wrapper: "" },
      sm: { wrapper: "" },
      md: { wrapper: "" },
      lg: { wrapper: "" },
      xl: { wrapper: "" },
      "2xl": { wrapper: "" },
      "3xl": { wrapper: "" },
      "4xl": { wrapper: "" },
      "5xl": { wrapper: "" },
      "6xl": { wrapper: "" },
      "7xl": { wrapper: "" }
    },
    applySpacing: {
      true: { wrapper: "px-[var(--spacing-x)]" },
      false: { wrapper: "my-component-spacing-none px-[unset]" }
    }
  },
  compoundVariants: [
    // If applySpacing is "true"
    {
      variants: { applySpacing: "true", y: "none" },
      slots: { wrapper: "my-component-spacing-none" }
    },
    {
      variants: { applySpacing: "true", y: "4xs" },
      slots: { wrapper: "my-component-spacing-4xs" }
    },
    {
      variants: { applySpacing: "true", y: "5xs" },
      slots: { wrapper: "my-component-spacing-5xs" }
    },
    {
      variants: { applySpacing: "true", y: "3xs" },
      slots: { wrapper: "my-component-spacing-3xs" }
    },
    {
      variants: { applySpacing: "true", y: "2xs" },
      slots: { wrapper: "my-component-spacing-2xs" }
    },
    {
      variants: { applySpacing: "true", y: "xs" },
      slots: { wrapper: "my-component-spacing-xs" }
    },
    {
      variants: { applySpacing: "true", y: "sm" },
      slots: { wrapper: "my-component-spacing-sm" }
    },
    {
      variants: { applySpacing: "true", y: "md" },
      slots: { wrapper: "my-component-spacing-md" }
    },
    {
      variants: { applySpacing: "true", y: "lg" },
      slots: { wrapper: "my-component-spacing-lg" }
    },
    {
      variants: { applySpacing: "true", y: "xl" },
      slots: { wrapper: "my-component-spacing-xl" }
    },
    {
      variants: { applySpacing: "true", y: "2xl" },
      slots: { wrapper: "my-component-spacing-2xl" }
    },
    {
      variants: { applySpacing: "true", y: "3xl" },
      slots: { wrapper: "my-component-spacing-3xl" }
    },
    {
      variants: { applySpacing: "true", y: "4xl" },
      slots: { wrapper: "my-component-spacing-4xl" }
    },
    {
      variants: { applySpacing: "true", y: "5xl" },
      slots: { wrapper: "my-component-spacing-5xl" }
    },
    {
      variants: { applySpacing: "true", y: "6xl" },
      slots: { wrapper: "my-component-spacing-6xl" }
    },
    {
      variants: { applySpacing: "true", y: "7xl" },
      slots: { wrapper: "my-component-spacing-7xl" }
    },
    {
      variants: { applySpacing: "true", x: "none" },
      slots: { wrapper: "[--spacing-x:0px] w-full box-border" }
    },
    {
      variants: { applySpacing: "true", x: "4xs" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-4xs)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "3xs" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-3xs)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "2xs" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-2xs)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "xs" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-xs)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "sm" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-sm)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "md" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-md)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "lg" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-lg)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "2xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-2xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "3xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-3xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "4xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-4xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "5xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-5xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "6xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-6xl)] w-full box-border"
      }
    },
    {
      variants: { applySpacing: "true", x: "7xl" },
      slots: {
        wrapper: "[--spacing-x:theme(space.component-spacing-7xl)] w-full box-border"
      }
    }
    // If applySpacing is "false"
    // {
    //   variants: { applySpacing: "false", y: "none" },
    //   slots: { wrapper: "my-component-spacing-none" },
    // },
  ],
  defaultVariants: {
    applySpacing: "true"
  }
}), e = p({
  slots: {
    wrapper: ""
  },
  variants: {
    background: {
      primary: { wrapper: "bg-primary text-black" },
      secondary: { wrapper: "bg-secondary text-white" },
      tertiary: { wrapper: "bg-tertiary text-white" },
      black: { wrapper: "bg-black text-white" },
      white: { wrapper: "bg-white" },
      grey: { wrapper: "bg-grey" },
      "surface-1": { wrapper: "bg-background-surface" },
      "surface-2": { wrapper: "bg-background-surface" },
      "surface-3": { wrapper: "bg-background-surface" }
    }
  }
}), s = p({
  slots: {
    wrapper: ""
  },
  variants: {
    maxWidth: {
      none: { wrapper: "" },
      sm: { wrapper: "" },
      md: { wrapper: "" },
      lg: { wrapper: "" },
      xl: { wrapper: "" },
      page: { wrapper: "" }
    },
    applyPosition: {
      true: { wrapper: "" },
      false: { wrapper: "" }
    }
  },
  compoundVariants: [
    {
      variants: { applyPosition: "true", maxWidth: "none" },
      slots: { wrapper: "max-w-component-max-w-none" }
    },
    {
      variants: { applyPosition: "true", maxWidth: "sm" },
      slots: {
        wrapper: "max-w-component-max-w-sm ml-auto mr-auto"
      }
    },
    {
      variants: { applyPosition: "true", maxWidth: "md" },
      slots: {
        wrapper: "max-w-component-max-w-md ml-auto mr-auto"
      }
    },
    {
      variants: { applyPosition: "true", maxWidth: "lg" },
      slots: {
        wrapper: "max-w-component-max-w-lg ml-auto mr-auto"
      }
    },
    {
      variants: { applyPosition: "true", maxWidth: "xl" },
      slots: {
        wrapper: "max-w-component-max-w-xl ml-auto mr-auto"
      }
    }
    // {
    //   variants: { applyPosition: "true", maxWidth: "page" },
    //   slots: {
    //     wrapper:
    //       "max-w-[max(var(--component-max-width-xl),var(--component-max-width-xl-px))] ml-auto mr-auto",
    //   },
    // },
  ],
  defaultVariants: {
    maxWidth: {
      initial: "none",
      lg: "xl"
    },
    applyPosition: "true"
  }
});
export {
  s as positionVariants,
  r as spacingVariants,
  e as themeVariants
};
//# sourceMappingURL=index-blueprint.es.js.map
